import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            width: "100%",
            height: "100%",
            flexGrow: 1,
            display: "flex",
            alignItems: "stretch",
            justifyContent: "stretch",
        },
        fade: {
            position: "relative",
            filter: "blur(1px) grayscale(100%)",
        },
        overlay: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "#dedede88",
            flexGrow: 1,
        },
    });

interface Props extends WithStyles<typeof styles> {
    children?: React.ReactNode;
    isLoading?: boolean;
}

export const FadeLoader = withStyles(styles, {
    name: "FadeLoader",
    withTheme: true,
})((props: Props) => {
    const { classes, children, isLoading } = props;

    const rootClass = classnames({
        [classes.root]: true,
        [classes.fade]: isLoading,
    });

    return (
        <div className={rootClass}>
            {children}
            {isLoading && <div className={classes.overlay} />}
        </div>
    );
});
